<template>
    <div>
      <div class="card">
        <div class="card-header row">
          <div class="col-8">
            <h5 class="card-title">Lobby Food Menu</h5>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <router-link :to="{ name: 'Lobby-Food-Add'}">
              <p-button type="info outline"  @click="handleInfo" outline round>
                <i slot="label" class="nc-icon nc-simple-add"></i>
                Add
              </p-button>
            </router-link>
          </div>
        </div>
        <div class="card-body row">
          <div class="col-sm-12">
            <el-table :data="tableData" header-row-class-name="text-info">
              <el-table-column type="index">
              </el-table-column>
              <el-table-column min-width="50">
                  <template slot-scope="props">
                    <div class="img-container">
                      <img :src="props.row.PictureURL" alt="Agenda">
                    </div>
                  </template>
                </el-table-column>
              <el-table-column prop="FoodType" min-width="50"
                               label="Type">
              </el-table-column>
              <el-table-column 
                                min-width="80"
                                prop="FoodName"
                               label="Name">
              </el-table-column>
              <el-table-column prop="FoodIngredients"
                               label="Ingredients">
              </el-table-column>
              <el-table-column prop="price"
                               min-width="30"
                               align="right"
                               label="Price">
              </el-table-column>
              <el-table-column
                class-name="action-buttons td-actions" min-width="40"
                align="center"
                label="Actions">
                <template slot-scope="props">
                  <p-button type="success" size="sm" icon @click="handleEdit(props.row.ItemID)">
                    <i class="fa fa-edit"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import { collection, getDocs, orderBy, query } from "firebase/firestore";
  import db from "@/components/Firebase/firebaseInit";

  import { Table, TableColumn } from "element-ui";
  Vue.use(Table);
  Vue.use(TableColumn);
  
  export default {
    data() {
      return {
        tableData: [], // Stores the fetched data for the table
      };
    },
    created() {
      this.fetchRegistrations();
    },
methods: {
  handleEdit(id) {
    this.$router.push({ name: "Lobby-Food-Edit", params: { id } });
  },
  async fetchRegistrations() {
    try {
      let id = 1;
      const foodMenuQuery = query(collection(db, "FoodMenu"), orderBy("FoodType")); // Corrected orderBy usage
      const querySnapshot = await getDocs(foodMenuQuery);
      const defaultImage = "https://firebasestorage.googleapis.com/v0/b/qr-bwp.firebasestorage.app/o/Internal%2Ffood.jpg?alt=media&token=4ca0e435-1ba7-41b7-a9ba-c584f946e76b"; // Replace with your default image URL

      this.tableData = querySnapshot.docs.map((doc) => ({
        id: id++, // Generate unique IDs for the rows
        ItemID: doc.id, // Store the document ID for editing
        PictureURL: doc.data().PictureURL ? doc.data().PictureURL : defaultImage, // Use default if PictureURL is missing
        FoodType: doc.data().FoodType, // Keep array intact for button rendering
        FoodName: doc.data().FoodName, // Display the AI task
        FoodIngredients: doc.data().FoodIngredients, // Display solution type
        price: doc.data().price + ' ETB', // Display solution type

      }));
    } catch (error) {
      console.error("Error fetching registrations:", error);
    }
  },
}

  };
  </script>
  
  
  <style lang="scss">
    .el-table .td-actions{
      button.btn {
        margin-right: 5px;
      }
    }
  </style>
  